import { Center } from "@mantine/core";
import { useTranslation } from "react-i18next";

const FinishStep = () => {
  const { t } = useTranslation();

  return <Center>{t("global.finish_step")}</Center>;
};
export default FinishStep;
